import { Component, Input } from '@angular/core';
import { texts } from './candidate-screening-questions.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-screening-questions',
  templateUrl: './candidate-screening-questions.component.html',
  styleUrls: ['./candidate-screening-questions.component.scss']
})
export class CandidateScreeningQuestionsComponent {

  texts = texts;

  @Input()
  candidate : any;

}
